<template>
  <div class="meTitle">
    <yd-navbar style="max-width: 750px;height:.88rem;" :title="title || $route.meta.title" fontsize="0.36rem" :bgcolor="bg || '#FFFFFF'" :color="'#282828'" :fixed="fixed">
      <a href="javascript:void(0)" slot="left" @click="goback"><i class="iconfont icon-Slicex9"></i></a>
    </yd-navbar>
    <div v-if="fixed" style="height: .88rem;"></div>
  </div>
</template>

<script>
export default {
  name: 'Thead',
  props: {
    bg: {
      type: String,
      default: '#FFFFFF'
    },
    fixed: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    isOther: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    goback () {
      if (!this.isOther) {
        this.appMethod.goback(this)
      }
      this.$emit('backEvent')
    }
  },
  mounted () {},
  watch: {
    $route () {}
  }
}
</script>

<style scope>
.meTitle {
  position: relative;
  z-index: 9999;
}

.yd-navbar:after {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Title/Thead.vue